export default __webpack_public_path__ + "static/media/mongoDB.87daf1c4.png";